import { computed, Injectable, signal } from '@angular/core';
import { faker } from '@faker-js/faker';
import { PendingTicket, SupportTicket } from '../../models/support';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  tickets = signal<SupportTicket[]>([])
  pendingTicket = signal<PendingTicket | null>(null)
  selectedTicket = signal<SupportTicket | null>(null)
  sortedTickets = computed(() => {
    return this.tickets().sort((a, b) => a.dateSubmitted.getTime() - b.dateSubmitted.getTime());
  }
  );

  constructor() {
    this.generateFakeTickets();
  }

  //TODO (for now it is just a mock)
  submitTicket(ticket: PendingTicket) {
    const supportTicket: SupportTicket = {
      referenceCode: faker.string.nanoid(10),
      description: `${ticket.category} - ${ticket.issue}`,
      summary: ticket.summary,
      dateSubmitted: new Date(),
      status: 'submitted',
      assignedStaff: faker.person.fullName()
    };
    const currentTickets = this.tickets();
    this.tickets.set([...currentTickets, supportTicket]);
    this.pendingTicket.set(null);
  }

  setSelectedTicket(params: { id: string; }) {
    const ticket = this.tickets().find(t => t.referenceCode === params.id);
    if (ticket) {
      this.selectedTicket.set(ticket);
    }
  }

  generateFakeTickets() {
    const tickets: SupportTicket[] = [];
    const amount = Math.floor(Math.random() * 10) + 1;
    for (let i = 0; i < amount; i++) {
      const ticket: SupportTicket = {
        referenceCode: faker.string.nanoid(10),
        description: faker.lorem.sentence(3),
        summary: faker.lorem.paragraph({ min: 1, max: 3 }),
        dateSubmitted: faker.date.past(),
        status: faker.helpers.arrayElement(['resolved', 'cancelled', 'in-progress', 'submitted']),
        assignedStaff: faker.person.fullName()
      };
      tickets.push(ticket);
    }
    this.tickets.set(tickets);
  }
}
